import { Component, OnInit, Input } from '@angular/core';
import { FormsTurnsService } from 'src/app/services/turns-services/forms-turns-service/forms-turns.service';
import { Router, ActivatedRoute } from '@angular/router';
import { UserStorageService } from 'src/app/services/user-storage-service/user-storage.service';

@Component({
  selector: 'app-turns-forms-breadcrumb-card',
  templateUrl: './turns-forms-breadcrumb-card.component.html',
  styleUrls: ['./turns-forms-breadcrumb-card.component.scss']
})
export class TurnsFormsBreadcrumbCardComponent implements OnInit {

  @Input() forms;
  filterOpened: boolean;
  viewDisposition;

  constructor(private router: Router,
              private activatedRoute: ActivatedRoute,
              private userStorageService: UserStorageService,
              private formsTurnsService: FormsTurnsService) {
                this.viewDisposition = 'grid';
              }

  ngOnInit() {
    if (this.userStorageService.getFilterForms()) {
      this.toggleBreadcrumbFilter();
    }
  }

  public toggleViewDisposition(viewDis) {
    this.viewDisposition = viewDis;
    this.formsTurnsService.toggleFormsDisposition(viewDis);
  }

  public createForm() {
    this.router.navigate(['../form'], { relativeTo: this.activatedRoute.parent });
  }

  public toggleBreadcrumbFilter() {
    this.filterOpened = !this.filterOpened;
  }

  public search(event) {
    this.formsTurnsService.searchForms(event.target.value);
  }
}
